import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BooleanInput, JsonInput } from '@ptl/global-components';
import { QuickLink } from '../interfaces/dynamic-link.interface';

//authoring only, dummy commit for release
@Component({
  selector: 'app-dynamic-link-layout',
  templateUrl: './dynamic-link-layout.component.html',
  styleUrls: ['./dynamic-link-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DynamicLinkLayoutComponent implements OnInit{

  @Input() headingHtml: string;
  @Input() linksPerRow: number = 2;
  @Input() @JsonInput() linkArray: QuickLink[] = [];

  constructor(){}

  ngOnInit(): void {
  }
}
